export const shortDescription = `
![EnvMakerLogo](https://media.discordapp.net/attachments/1164516702554427472/1164901515023093770/Env_maker_logo_Light.png)

This graphical DSL allows for blueprint creation of environments, to be used in IoT and CPS applications.

![Example](https://media.discordapp.net/attachments/1171772074545664001/1171772610128904282/image.png)
`;
